import { Button, UIHeading2, UIText1 } from '@cian/ui-kit';
import * as React from 'react';

import styles from './styles.css';

export interface IEmptyListProps {
  isAuthenticated: boolean;
  onClick: () => void;
}

export const EmptyList: React.FC<IEmptyListProps> = ({ isAuthenticated, onClick }) => {
  return (
    <div className={styles['container']}>
      <div className={styles['img']} />
      <div>
        <div className={styles['title']}>
          <UIHeading2>Сделайте поиск удобнее</UIHeading2>
        </div>
        <UIText1 color="text-secondary-default">Сохраняйте поиски, чтобы не&nbsp;пропустить новые предложения</UIText1>
      </div>
      <Button size="L" theme="fill_primary" fullWidth onClick={onClick}>
        {isAuthenticated ? 'Сохранить последний поиск' : 'Войти'}
      </Button>
    </div>
  );
};
